const mockData = {
  data: {
    contextItem: {
      path: '/sitecore/content/internet/home/view-user-dashboard',
      id: '21676E76437B581FA48D69D36F546A5B',
    },
    datasourceItem: {
      heading: {
        value: 'Dashboard',
      },
      description: {
        value: 'All information on the dashboard is based on the last 30 days.\n',
      },
      children: [
        {},
        {},
        {
          displayName: 'Quote Tracking Dashboard',
          id: 'EEA566F1C0485FD186C329DB18BDFFB0',
          heading: {
            value: 'Quote Summary',
          },
          loadingText: {
            value: "We're working on gathering your Quotes...",
          },
          manageQuotesLink: {
            jss: {
              value: {
                href: '/manage-quotes',
                text: 'Manage Quotes',
                linktype: 'internal',
                id: '{3E160D78-3599-566D-91E5-87C52559447A}',
              },
            },
            targetItem: {
              id: '3E160D783599566D91E587C52559447A',
            },
          },
          noResultsText: {
            value: 'You don’t have any quotes yet!',
          },
          requestQuoteLink: {
            jss: {
              value: {
                href: '/create-quote',
                text: 'Request A Quote',
                linktype: 'internal',
                id: '{573D9549-05E6-5956-AF90-FEFD157A00B4}',
              },
            },
            targetItem: {
              id: '573D954905E65956AF90FEFD157A00B4',
            },
          },
        },
        {
          displayName: 'Shipment Tracking Dashboard',
          id: '9813160566B4588BBE6F0A3CFA5E1235',
          heading: {
            value: 'Shipment Tracking',
          },
          loadingText: {
            value: "We're working on gathering your Shipments...",
          },
          manageShipmentsLink: {
            jss: {
              value: {
                href: '/manage-orders',
                text: 'Manage Shipments',
                linktype: 'internal',
                id: '{25C4C56C-FA8E-533D-B272-1A035E08ED94}',
              },
            },
            targetItem: {
              id: '25C4C56CFA8E533DB2721A035E08ED94',
            },
          },
          noResultsText: {
            value: 'You don’t have any shipments yet!',
          },
          trackShipmentsLink: {
            jss: {
              value: {
                href: '/track-shipments',
                text: 'Track Shipments',
                linktype: 'internal',
                id: '{8D5C0E11-00E5-5420-A0B2-5B39DDBBA830}',
              },
            },
            targetItem: {
              id: '8D5C0E1100E55420A0B25B39DDBBA830',
            },
          },
        },
        {},
      ],
    },
    drsearch: {
      results: {
        items: [
          {
            item: {
              id: '9443E68B6017421BB99FD7789D3DC7C8',
              name: '2019 Women in Trucking',
              path: '/sitecore/content/internet/home/2019 Women in Trucking',
              url: '/2019-Women-in-Trucking',
              heading: {
                value: 'Day & Ross recognized as one of the 2019 Top Companies for Women to Work for in Transportation ',
              },
              description: {
                value: '',
              },
              heroImage: {
                jss: {
                  value: {
                    // eslint-disable-next-line max-len
                    src: 'https://mc-0fc7c845-fa69-4349-b0c9-3104-cm.azurewebsites.net/-/media/trophy.ashx?h=760&iar=0&w=1140&hash=419077C5DF8524122614E4CF27DF3131',
                    alt: 'Award',
                    width: '1140',
                    height: '760',
                  },
                },
              },
            },
          },
          {
            item: {
              id: '6DD2A84BA1234686A3F2AF729013BAC6',
              name: 'New Day 2',
              path: '/sitecore/content/internet/home/New Day 2',
              url: '/New-Day-2',
              heading: {
                value: 'New Day 2',
              },
              description: {
                value: 'Happy News',
              },
              heroImage: {
                jss: {
                  value: {
                    // eslint-disable-next-line max-len
                    src: 'https://mc-0fc7c845-fa69-4349-b0c9-3104-cm.azurewebsites.net/-/media/internet/data/media/img/home/truck2.ashx?h=528&iar=0&w=1440&hash=D6A7C5D4E190655A8CC347AE75A118EB',
                    alt: 'test',
                    width: '1440',
                    height: '528',
                  },
                },
              },
            },
          },
          {
            item: {
              id: 'A5560CA0DDB15781A6DF7C817AE8946C',
              name: 'static-page',
              path: '/sitecore/content/internet/home/static-page',
              url: '/static-page',
              heading: {
                value: 'Static Page Heading',
              },
              description: {
                // eslint-disable-next-line max-len
                value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer tincidunt venenatis ullamcorper. Sed imperdiet congue risus, ut aliquam enim vehicula vel. Quisque aliquam bibendum lacus, sed dictum diam fringilla ultrices. In id dui orci. Nam rhoncus leo in tincidunt pellentesque. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean est mauris, placerat at tortor ac, accumsan venenatis ex. Nam pulvinar libero ut blandit tristique. Aliquam dictum lobortis lacinia. Duis finibus congue ligula in vehicula. Curabitur ac fermentum mi. Suspendisse in massa non massa interdum tincidunt nec id felis. Suspendisse dictum urna sed sagittis blandit.\n',
              },
              heroImage: {
                jss: {
                  value: {
                    // eslint-disable-next-line max-len
                    src: 'https://mc-0fc7c845-fa69-4349-b0c9-3104-cm.azurewebsites.net/-/media/internet/data/media/img/home/Truck.ashx?h=923&iar=0&w=1440&hash=85597552551E66DDDC83803EB7303164',
                    alt: 'te',
                    width: '1440',
                    height: '923',
                  },
                },
              },
            },
          },
          {
            item: {
              id: 'F46217CD8EC34FECBFFC842A67C6611B',
              name: 'drive',
              path: '/sitecore/content/internet/home/drive',
              url: '/drive',
              heading: {
                value: 'New Article section',
              },
              description: {
                value: 'Very nice article for D&amp;R',
              },
              heroImage: {
                jss: {
                  value: {
                    // eslint-disable-next-line max-len
                    src: 'https://mc-0fc7c845-fa69-4349-b0c9-3104-cm.azurewebsites.net/-/media/internet/data/media/img/home/truck2.ashx?h=528&iar=0&w=1440&hash=D6A7C5D4E190655A8CC347AE75A118EB',
                    alt: 'test',
                    width: '1440',
                    height: '528',
                  },
                },
              },
            },
          },
          {
            item: {
              id: 'ED533CF3531844388189AD5D1AF7A94A',
              name: 'Happy News',
              path: '/sitecore/content/internet/home/Happy News',
              url: '/Happy-News',
              heading: {
                value: 'Happy News',
              },
              description: {
                value: 'Happy News',
              },
              heroImage: {
                jss: {
                  value: {
                    // eslint-disable-next-line max-len
                    src: 'https://mc-0fc7c845-fa69-4349-b0c9-3104-cm.azurewebsites.net/-/media/internet/data/media/img/home/truck2.ashx?h=528&iar=0&w=1440&hash=D6A7C5D4E190655A8CC347AE75A118EB',
                    alt: 'test',
                    width: '1440',
                    height: '528',
                  },
                },
              },
            },
          },
          {
            item: {
              id: '63DFFA6ECBED40C1B608F4A4786DD69D',
              name: 'Happy Happy Happy',
              path: '/sitecore/content/internet/home/Happy Happy Happy',
              url: '/Happy-Happy-Happy',
              heading: {
                value: 'Happy Happy Happy',
              },
              description: {
                value: 'Happy News',
              },
              heroImage: {
                jss: {
                  value: {
                    // eslint-disable-next-line max-len
                    src: 'https://mc-0fc7c845-fa69-4349-b0c9-3104-cm.azurewebsites.net/-/media/internet/data/media/img/home/truck2.ashx?h=528&iar=0&w=1440&hash=D6A7C5D4E190655A8CC347AE75A118EB',
                    alt: 'test',
                    width: '1440',
                    height: '528',
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
};

export default mockData;
